import { useCallback } from 'react'

/**
 * Hook to scroll to the first form error when validation fails
 * @returns scrollToFirstError function
 */
export const useScrollToError = () => {
  const scrollToFirstError = useCallback(() => {
    setTimeout(() => {
      // Try multiple selectors to find the first error
      const selectors = [
        '[data-invalid="true"]', // Radix UI invalid state
        '[aria-invalid="true"]', // ARIA invalid state
        '[role="alert"]', // Alert role
        '.text-destructive[role="alert"]', // Error message with destructive class
        'p.text-destructive' // Error paragraph with destructive class
      ]

      let firstErrorElement: HTMLElement | null = null

      for (const selector of selectors) {
        firstErrorElement = document.querySelector(selector) as HTMLElement
        if (firstErrorElement) {
          break
        }
      }

      if (firstErrorElement) {
        // Scroll to the error element
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })

        // Try to focus on the associated input
        const formItem =
          firstErrorElement.closest('[class*="space-y"]') ||
          firstErrorElement.closest('.rounded-lg') ||
          firstErrorElement.parentElement
        if (formItem) {
          const input = formItem.querySelector('input, textarea, select, button[role="combobox"]') as HTMLElement
          if (input) {
            setTimeout(() => {
              input.focus()
            }, 300)
          }
        }
      }
    }, 100)
  }, [])

  return { scrollToFirstError }
}
